import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {InfiniteScroll, PullToRefresh, List, Ellipsis, NavBar, SwipeAction, Dialog, Empty} from 'antd-mobile';
import {deletePropertyHistory, getPropertyHistoryList,} from "../../services/property";
import toast from "../../utils/toast";
import response from "../../utils/response";

import './historylist.css';

const PropertyHistoryList = () => {
    const navigate = useNavigate();
    const [list, setList] = useState([]);
    const [hasMore, setHasMore] = useState(true);
    const [page, setPage] = useState(1);
    const perPage = 15;

    function getData(isRefresh) {
        setHasMore(false);

        getPropertyHistoryList({
            page: isRefresh ? 1 : page,
            per_page: perPage
        }).then(res => {
            const {code, data} = res || {};

            if (response.isSuccess(code)) {
                setHasMore(data.current_page < data.last_page);

                if (isRefresh) {
                    setPage(2);
                    setList(data.data);
                } else {
                    setPage(() => data.current_page + 1);
                    setList(val => [...val, ...data.data]);
                }
            }
        });
    }

    useEffect(() => {
        getData(true);
        // eslint-disable-next-line
    }, []);

    function handleGoBack() {
        navigate(-1);
    }

    function handleClick(id) {
        navigate('/property/historyDetails/' + id);
    }

    function handleDelete(id) {
        Dialog.confirm({
            content: '确定要删除吗？',
            onConfirm: async () => {
                deletePropertyHistory(id).then(res => {
                    const {code} = res || {};

                    if (response.isSuccess(code)) {
                        toast.success('删除成功');

                        const newList = list.filter(item => item.id !== id);
                        setList(newList);
                    }
                });
            },
        });
    }

    return (
        <div className="page-container">
            <div className="page-top" onClick={() => {
            }}>
                <NavBar
                    onBack={handleGoBack}
                >
                    资产趋势
                </NavBar>
            </div>
            <div className="page-body page-bg">
                <PullToRefresh
                    onRefresh={() => getData(true)}
                >
                    {list.length > 0 ? (
                        <>
                            <List>
                                {list.map(item => (
                                    <SwipeAction
                                        key={item.id}
                                        rightActions={[
                                            {
                                                key: 'delete',
                                                text: '删除',
                                                color: 'danger',
                                                onClick: () => handleDelete(item.id),
                                            },
                                        ]}
                                    >
                                        <List.Item
                                            key={item.id}
                                            description={
                                                <div className="property-historylist-amount">
                                                    <div><span>净资产</span><span>{item.net_assets}</span></div>
                                                    <div><span>总资产</span><span>{item.property_amount}</span></div>
                                                    <div><span>总负债</span><span>{item.liabilities_amount}</span></div>
                                                </div>
                                            }
                                            onClick={() => handleClick(item.id)}
                                        >
                                            <div className="property-historylist-memo">
                                                <Ellipsis direction='end' content={item.data_date}/>
                                            </div>
                                        </List.Item>
                                    </SwipeAction>
                                ))}
                            </List>
                            <InfiniteScroll loadMore={() => getData(false)} hasMore={hasMore}/>
                        </>
                    ) : (
                        <List>
                            <Empty
                                style={{padding: '64px 0'}}
                                description='暂无数据'
                            />
                        </List>
                    )}
                </PullToRefresh>
            </div>
        </div>
    )
};

export default PropertyHistoryList;